const formatHobby = (hobby) => ({
  value: typeof hobby === 'string' ? hobby.toUpperCase() : hobby,
  label: typeof hobby === 'string' ? hobby.charAt(0).toUpperCase() + hobby.slice(1).toLowerCase() : hobby,
});

export const formatLocation = (loc) => {
  if (!loc) return null;
  // If already an option-like object { value, label }
  if (typeof loc === 'object' && loc.value !== undefined && loc.label !== undefined) {
    return loc;
  }
  // If API returns { id, name } or { id, value }
  if (typeof loc === 'object') {
    const id = loc.id ?? loc.value ?? null;
    const label = loc.name ?? loc.value ?? '';
    return id != null ? { value: id, label: String(label) } : null;
  }
  return { value: loc, label: String(loc) };
};
export const formatDob = (dateString) => (dateString ? new Date(dateString.split('-').reverse().join('-')) : null);

export const formatHobbies = (hobbies) => {
  if (Array.isArray(hobbies)) {
    return hobbies.map(formatHobby);
  }
  if (typeof hobbies === 'string') {
    return hobbies
      .split(',')
      .map((h) => h.trim().toUpperCase())
      .filter(Boolean)
      .map(formatHobby);
  }
  return [];
};

export const TABS = {
  BASIC: 'Basic',
  LICENSING: 'Licensing',
  DOCUMENTS: 'Documents',
};

// ...existing code...

export const formatOptions = (items) => {
  if (!Array.isArray(items)) {
    return [];
  }
  return items
    .map((item) => {
      if (!item) return null;

      // Get the ID/value field
      const value = item.id ?? item.stateId ?? item.cityId ?? item.countryId ?? item.salesAreaId ?? item.code ?? item.value;

      // Get the label field - handle different API response formats
      let label = '';

      // For edit mode sales areas: {id: 119, value: "Saket"}
      if (item.value && typeof item.value === 'string' && item.id) {
        label = item.value;
      } else {
        label = item.name ?? item.stateName ?? item.cityName ?? item.countryName ?? item.salesAreaName ?? item.areaName ?? item.label ?? item.value ?? '';
      }

      if (value == null || !label) return null;
      return { value, label };
    })
    .filter(Boolean);
};
